/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
    Grid,
    MenuItem,
    TextField,
    Typography,
    Button,
    Divider,
    CircularProgress,
    Card,
    CardContent,
    Toolbar,
    Box,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import Select from "react-select";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import { Close as CloseIcon } from "@material-ui/icons";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import ckLogo from "../../../assets/images/ck_logo_new.png";

const ASPECT_RATIO_TOLERANCE = 0.01;

const getExpectedAspectRatio = (sizeId, pageNumber, slotNumber, categoryId) => {
    const id = parseInt(categoryId);
    const totalPages = { 2: 24, 6: 12, 9: 1 }[id] || 0;
    const isFrontCover = pageNumber === 1;
    const isBackCover = pageNumber === totalPages && totalPages > 1;

    if (id === 2) {
        if (sizeId === 2) {
            if (isFrontCover) return 3796 / 3000;
            if (isBackCover) return 4010 / 3000;
            return 3508 / 2400;
        }
        if (sizeId === 4) {
            if (isFrontCover) return 2737 / 3000;
            if (isBackCover) return 2961 / 3000;
            return 2400 / 2400;
        }
    } else if (id === 9) {
        if (sizeId === 22) return 2550 / 1050;
        if (sizeId === 23) return 2550 / 1125;
        return 2550 / 1050;
    } else if (id === 6) {
        if (sizeId === 12 || sizeId === 14) return 3600 / 5400;
        if (sizeId === 15) return 3600 / 3600;
        return 3600 / 5400;
    }

    // if (id === 2) {
    //     if (sizeId === "Landscape") {
    //         if (isFrontCover) return 3796 / 3000;
    //         if (isBackCover) return 4010 / 3000;
    //         return 3508 / 2400;
    //     }
    //     if (sizeId === "Square") {
    //         if (isFrontCover) return 2737 / 3000;
    //         if (isBackCover) return 2961 / 3000;
    //         return 2400 / 2400;
    //     }
    // } else if (id === 9) {
    //     if (sizeId === "Regular Mug") return 2550 / 1050;
    //     if (sizeId === "Big Mug") return 2550 / 1125;
    //     return 2550 / 1050;
    // } else if (id === 6) {
    //     if (sizeId === "Classic 12x18''" || sizeId === "Portrait 12x18''") return 3600 / 5400;
    //     if (sizeId === "Square 12x12''") return 3600 / 3600;
    //     return 3600 / 5400;
    // }
    return null;
};

const useStyles = () => ({
    root: { padding: 10, margin: "70px 20px" },
    topMargin: { marginTop: 20 },
    button: { textTransform: "capitalize", marginLeft: 10, padding: 10, width: 110 },
});

class F15ThemeProductsAssetsFormWithFolder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            recordId: 0,

            // ── Dropdown Data ──
            categoriesList: [],
            categoriesLoading: false,
            themeCategoriesList: [],
            themeCategoriesLoading: false,
            sizesList: [],
            sizesLoading: false,
            totalPagesList: [],
            productTypesList: [],
            productTypesLoading: false,
            bundlesList: [],
            bundlesLoading: false,
            layoutsList: [],
            layoutsLoading: false,

            // ── Selected Values ──
            categoryId: "",
            categoryIdError: "",
            themeCategoryId: "",
            themeCategoryIdError: "",
            sizeId: "",
            sizeIdError: "",
            totalPages: "",
            totalPagesError: "",
            selectedProductTypes: [],
            selectedProductTypesError: "",
            selectedBundles: [],
            selectedBundlesError: "",

            // ── Text Fields ──
            description: "",
            descriptionError: "",
            themeLabel: "",
            themeLabelError: "",

            // ── Assets ──
            templateImages: [],
            previewImage: null,
            previewImageError: "",
            thumbnailImage: null,
            thumbnailImageError: "",
            folderUploadError: "",

            // ── UI State ──
            isOpenSnackbar: false,
            snackbarMessage: "",
            snackbarSeverity: "",
            isLoginMenu: false,
            isReload: true,
        };
    }

    componentDidMount() {
        this.fetchCategories();
        this.fetchThemeCategories();
        const id = this.props.match?.params?.recordId;
        if (id && id != 0) {
            this.setState({ recordId: id });
            this.getData(id);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.match?.params?.recordId != nextProps.match?.params?.recordId) {
            if (nextProps.match?.params?.recordId != 0) {
                this.getData(nextProps.match?.params?.recordId);
            } else {
                window.location.reload();
            }
        }
    }

    // ── API Calls ──

    fetchCategories = async () => {
        this.setState({ categoriesLoading: true });
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsCategoriesView`,
            null, "authorizeJson");
        if (res.isSuccess) {
            const ALLOWED_IDS = [2, 6, 9];
            const ALIAS_MAP = { 2: "pb", 6: "cl", 9: "mg" };
            const filtered = (res.data || [])
                .filter((item) => ALLOWED_IDS.includes(item.id))
                .map((item) => ({ ...item, alias: ALIAS_MAP[item.id] || "" }));
            this.setState({ categoriesList: filtered });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
        this.setState({ categoriesLoading: false });
    };

    fetchThemeCategories = async () => {
        this.setState({ themeCategoriesLoading: true });
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeCategoriesView`,
            null, "authorizeJson");
        if (res.isSuccess) {
            this.setState({ themeCategoriesList: res.data || [] });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
        this.setState({ themeCategoriesLoading: false });
    };

    fetchSizes = async (categoryId) => {
        this.setState({ sizesLoading: true });
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsSizesView?categoryId=${categoryId}`,
            null, "authorizeJson");
        if (res.isSuccess) {
            this.setState({ sizesList: res.data || [] });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
        this.setState({ sizesLoading: false });
    };

    fetchProductTypes = async (categoryId) => {
        this.setState({ productTypesLoading: true });
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsTypesView?categoryId=${categoryId}`,
            null, "authorizeJson");
        if (res.isSuccess) {
            const list = (res.data || []).map((item) => ({
                value: item.id, label: item.label, id: item.id,
                isFixed: false, isDisabled: false,
            }));
            this.setState({ productTypesList: list });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
        this.setState({ productTypesLoading: false });
    };

    fetchBundles = async (categoryId) => {
        this.setState({ bundlesLoading: true });
        if (categoryId == 9) {
            this.setState({
                bundlesList: [
                    { value: 1, label: "Bundle of 1", id: 1 },
                    { value: 2, label: "Bundle of 2", id: 2 },
                ],
            });
        } else {
            this.setState({ bundlesList: [] });
        }
        this.setState({ bundlesLoading: false });
    };

    fetchLayouts = async (categoryId) => {
        this.setState({ layoutsLoading: true });
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeAssetsLayoutsController?categoryId=${categoryId}`,
            null, "authorizeJson");
        if (res.isSuccess) {
            this.setState({ layoutsList: res.data || [] });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
        this.setState({ layoutsLoading: false });
    };

    buildTotalPagesList = (categoryId) => {
        let pages = [];
        if (categoryId == 2) pages = [{ value: 24, label: "24 Pages" }];
        else if (categoryId == 6) pages = [{ value: 12, label: "12 Pages" }];
        else if (categoryId == 9) pages = [{ value: 1, label: "1 Page" }];
        this.setState({ totalPagesList: pages, totalPages: pages.length === 1 ? pages[0].value : "" });
    };

    buildTemplateSlots = (categoryId) => {
        const pagesMap = { 2: 24, 6: 12, 9: 1 };
        const totalPages = pagesMap[parseInt(categoryId)] || 0;
        const slots = [];
        for (let page = 1; page <= totalPages; page++) {
            for (let slot = 1; slot <= 2; slot++) {
                slots.push({
                    pageNumber: page,
                    slotNumber: slot,
                    slotLabel: slot === 1 ? "App Asset" : "Print Asset",
                    slotKey: `page${page}_slot${slot}`,
                    file: null,
                    preview: null,
                    dimensions: null,
                    layoutId: "",
                    layoutIdError: "",
                    generatedFileName: "",
                });
            }
        }
        this.setState({ templateImages: slots });
    };

    getData = async (id) => {
        const res = await HttpRequest("GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesFormView?recordId=${id}`,
            null, "authorizeJson");
        if (res.isSuccess && res.data && res.data.length > 0) {
            const d = res.data[0];
            this.setState({
                categoryId: d.categoryId || "",
                themeCategoryId: d.themeCategoryId || "",
                sizeId: d.sizeId || "",
                totalPages: d.totalPages || "",
                description: d.description || "",
                themeLabel: d.themeLabel || "",
                selectedProductTypes: d.productTypes
                    ? d.productTypes.map((pt) => ({ value: pt.id, label: pt.label, id: pt.id }))
                    : [],
            });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
            else this.handleSnackbar(true, res.message || "Failed to load data", "error");
        }
    };

    // ── Helpers ──

    confirmReset = (message, onConfirm) => {
        if (window.confirm(message)) onConfirm();
    };

    handleSnackbar = (isOpen, message, severity) => {
        this.setState({ isOpenSnackbar: isOpen, snackbarMessage: message, snackbarSeverity: severity });
    };

    resetDependentState = (extraState = {}, callback) => {
        this.setState({
            themeCategoryId: "", themeCategoryIdError: "",
            sizeId: "", sizeIdError: "",
            totalPages: "", totalPagesError: "",
            selectedProductTypes: [], selectedProductTypesError: "",
            selectedBundles: [], selectedBundlesError: "",
            bundlesList: [], sizesList: [], productTypesList: [], layoutsList: [],
            themeLabel: "", themeLabelError: "",
            description: "", descriptionError: "",
            templateImages: [],
            previewImage: null, previewImageError: "",
            thumbnailImage: null, thumbnailImageError: "",
            folderUploadError: "",
            ...extraState,
        }, callback);
    };

    // ── Change Handlers ──

    handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "categoryId") {
            const doChange = () => {
                this.resetDependentState({ categoryId: value || "", categoryIdError: "" }, () => {
                    if (value) {
                        this.fetchSizes(value);
                        this.fetchProductTypes(value);
                        this.buildTotalPagesList(value);
                        this.buildTemplateSlots(value);
                        this.fetchLayouts(value);
                        this.fetchBundles(value);
                    }
                });
            };
            if (this.state.categoryId) {
                this.confirmReset("Changing the category will reset all progress. Continue?", doChange);
            } else {
                doChange();
            }
            return;
        }

        if (name === "themeCategoryId") {
            if (this.state.sizeId) {
                this.confirmReset("Changing the theme category will reset size and selections. Continue?", () => {
                    this.setState({
                        [name]: value || "", [`${name}Error`]: "",
                        sizeId: "", sizeIdError: "",
                        totalPages: "", totalPagesError: "",
                        selectedProductTypes: [], selectedProductTypesError: "",
                        selectedBundles: [], selectedBundlesError: "",
                        themeLabel: "", themeLabelError: "",
                        description: "", descriptionError: "",
                    });
                });
            } else {
                this.setState({ [name]: value || "", [`${name}Error`]: "" });
            }
            return;
        }

        this.setState({ [name]: value || "", [`${name}Error`]: "" });
    };

    handleProductTypesChange = (selected) => {
        this.setState({ selectedProductTypes: selected || [], selectedProductTypesError: "" });
    };

    handleBundlesChange = (selected) => {
        this.setState({ selectedBundles: selected || [], selectedBundlesError: "" });
    };

    // ── Folder Upload ──

    parseFileNameMeta = (fileName) => {
        const nameWithoutExt = fileName.replace(/\.[^/.]+$/, "");
        const parts = nameWithoutExt.split("_");
        if (parts.length < 2) return null;
        const pageNumber = parseInt(parts[0]);
        const assetType = parts[1]; // "ic" or "fl"
        const layoutNo = parts[parts.length - 1];
        if (isNaN(pageNumber)) return null;
        if (assetType !== "ic" && assetType !== "fl") return null;
        return { pageNumber, slotNumber: assetType === "ic" ? 1 : 2, layoutNo };
    };

    handleFolderUpload = async (e) => {
        const files = Array.from(e.target.files);
        e.target.value = "";
        if (!files.length) return;

        const VALID_FOLDERS = {
            "app asset": "appAsset",
            "print asset": "printAsset",
            "preview": "preview",
            "thumbnail": "thumbnail",
        };

        const categorized = { appAsset: [], printAsset: [], preview: [], thumbnail: [] };
        const unknownFolders = new Set();

        files.forEach((file) => {
            const parts = file.webkitRelativePath.split("/");
            const subFolder = parts.length >= 3 ? parts[1].toLowerCase().trim() : null;
            const key = subFolder ? VALID_FOLDERS[subFolder] : null;
            if (key) categorized[key].push(file);
            else if (subFolder) unknownFolders.add(parts[1]);
        });

        if (unknownFolders.size > 0) {
            this.handleSnackbar(true,
                `Unknown subfolder(s): "${[...unknownFolders].join('", "')}". Expected: App Asset, Print Asset, Preview${this.state.categoryId == 6 ? ", Thumbnail" : ""}.`,
                "warning");
        }

        const { sizesList, sizeId, categoryId, layoutsList } = this.state;
        const sizeItem = sizesList.find((s) => s.id == sizeId);
        const sizeLabel = sizeItem?.label || sizeItem?.userLabel || "";
        //  sizeId = sizeItem?.id || sizeItem?.id || "";

        // Reset all slots first
        const freshSlots = this.state.templateImages.map((s) => ({
            ...s, file: null, preview: null, dimensions: null,
            layoutId: "", layoutIdError: "", generatedFileName: "",
        }));
        const updatedSlots = [...freshSlots];

        // Process App Asset + Print Asset files
        const assetFiles = [...categorized.appAsset, ...categorized.printAsset];
        const errors = [];

        await Promise.all(assetFiles.map((file) => new Promise((resolve) => {
            const meta = this.parseFileNameMeta(file.name);
            if (!meta) return resolve();

            const slotIdx = updatedSlots.findIndex(
                (s) => s.pageNumber === meta.pageNumber && s.slotNumber === meta.slotNumber
            );
            if (slotIdx === -1) return resolve();

            const layoutItem = layoutsList.find((l) => String(l.layoutNo) === String(meta.layoutNo));
            const layoutId = layoutItem?.layoutId || "";
            const preview = URL.createObjectURL(file);
            const img = new Image();

            img.onload = () => {
                const expectedRatio = getExpectedAspectRatio(sizeId, meta.pageNumber, meta.slotNumber, categoryId);
                if (expectedRatio) {
                    const actualRatio = img.width / img.height;
                    if (Math.abs(actualRatio - expectedRatio) > ASPECT_RATIO_TOLERANCE) {
                        URL.revokeObjectURL(preview);
                        errors.push(`Wrong aspect ratio for ${file.name}. Expected ~${expectedRatio.toFixed(4)}, got ${actualRatio.toFixed(4)} (${img.width}×${img.height}px).`);
                        return resolve();
                    }
                }
                updatedSlots[slotIdx] = {
                    ...updatedSlots[slotIdx],
                    file, preview,
                    dimensions: { width: img.width, height: img.height },
                    layoutId, layoutIdError: "",
                    generatedFileName: file.name,
                };
                resolve();
            };
            img.onerror = () => resolve();
            img.src = preview;
        })));

        // Process Preview
        let previewImage = null;
        if (categorized.preview.length > 0) {
            const file = categorized.preview[0];
            const preview = URL.createObjectURL(file);
            await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => { previewImage = { file, preview, dimensions: { width: img.width, height: img.height } }; resolve(); };
                img.onerror = () => resolve();
                img.src = preview;
            });
        }

        // Process Thumbnail — Calendar only
        let thumbnailImage = null;
        if (this.state.categoryId == 6 && categorized.thumbnail.length > 0) {
            const file = categorized.thumbnail[0];
            const preview = URL.createObjectURL(file);
            await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => { thumbnailImage = { file, preview, dimensions: { width: img.width, height: img.height } }; resolve(); };
                img.onerror = () => resolve();
                img.src = preview;
            });
        }

        const filled = updatedSlots.filter((s) => s.file).length;
        const total = updatedSlots.length;

        this.setState({
            templateImages: updatedSlots,
            previewImage: previewImage || null,
            thumbnailImage: thumbnailImage || null,
            previewImageError: "",
            thumbnailImageError: "",
            folderUploadError: errors.length > 0 ? errors.join("\n") : "",
        }, () => {
            if (errors.length > 0) {
                this.handleSnackbar(true, `${errors.length} file(s) failed validation.`, "error");
            } else {
                this.handleSnackbar(true, `Folder uploaded: ${filled}/${total} asset slots filled.`, "success");
            }
        });
    };

    // ── Individual Slot Handlers ──

    handleTemplateImageUpload = (slotKey, file) => {
        if (!file) return;
        const preview = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            const { sizesList, sizeId, categoryId, templateImages } = this.state;
            const sizeItem = sizesList.find((s) => s.id == sizeId);
            const sizeLabel = sizeItem?.label || sizeItem?.userLabel || "";
            const slot = templateImages.find((s) => s.slotKey === slotKey);
            const expectedRatio = slot ? getExpectedAspectRatio(sizeLabel, slot.pageNumber, slot.slotNumber, categoryId) : null;

            if (expectedRatio) {
                const actualRatio = img.width / img.height;
                if (Math.abs(actualRatio - expectedRatio) > ASPECT_RATIO_TOLERANCE) {
                    URL.revokeObjectURL(preview);
                    this.handleSnackbar(true,
                        `Wrong aspect ratio for ${slotKey}. Expected ~${expectedRatio.toFixed(4)}, got ${actualRatio.toFixed(4)} (${img.width}×${img.height}px).`,
                        "error");
                    return;
                }
            }
            this.setState((prev) => ({
                templateImages: prev.templateImages.map((s) =>
                    s.slotKey !== slotKey ? s : {
                        ...s, file, preview,
                        dimensions: { width: img.width, height: img.height },
                        generatedFileName: file.name,
                    }
                ),
            }));
        };
        img.src = preview;
    };

    handleTemplateImageRemove = (slotKey) => {
        this.setState((prev) => ({
            templateImages: prev.templateImages.map((s) =>
                s.slotKey === slotKey
                    ? { ...s, file: null, preview: null, dimensions: null, generatedFileName: "" }
                    : s
            ),
        }));
    };

    handlePreviewImageUpload = (file) => {
        if (!file) return;
        const preview = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            this.setState({ previewImage: { file, preview, dimensions: { width: img.width, height: img.height } }, previewImageError: "" });
        };
        img.src = preview;
    };

    handlePreviewImageRemove = () => this.setState({ previewImage: null, previewImageError: "" });

    handleThumbnailImageUpload = (file) => {
        if (!file) return;
        const preview = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            this.setState({ thumbnailImage: { file, preview, dimensions: { width: img.width, height: img.height } }, thumbnailImageError: "" });
        };
        img.src = preview;
    };

    handleThumbnailImageRemove = () => this.setState({ thumbnailImage: null, thumbnailImageError: "" });

    // ── Validation & Submit ──

    isFormValid = () => {
        let isValid = true;
        const errors = {};

        if (!this.state.categoryId) { isValid = false; errors.categoryIdError = "Please select a category."; }
        if (!this.state.themeCategoryId) { isValid = false; errors.themeCategoryIdError = "Please select a theme category."; }
        if (!this.state.sizeId) { isValid = false; errors.sizeIdError = "Please select a size."; }
        if (!this.state.totalPages) { isValid = false; errors.totalPagesError = "Please select total pages."; }
        if (!this.state.selectedProductTypes || this.state.selectedProductTypes.length === 0) {
            isValid = false; errors.selectedProductTypesError = "Please select at least one product type.";
        }
        if (!this.state.description) { isValid = false; errors.descriptionError = "Please enter description."; }
        if (!this.state.previewImage) { isValid = false; errors.previewImageError = "Please upload preview image."; }
        if (this.state.categoryId == 6 && !this.state.thumbnailImage) {
            isValid = false; errors.thumbnailImageError = "Please upload thumbnail image.";
        }

        const emptySlots = this.state.templateImages.filter((s) => !s.file);
        if (emptySlots.length > 0) {
            isValid = false;
            this.handleSnackbar(true,
                `${emptySlots.length} slot(s) empty: ${emptySlots.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
                "error");
        }

        const emptyLayouts = this.state.templateImages.filter((s) => s.file && !s.layoutId);
        if (emptyLayouts.length > 0) {
            isValid = false;
            this.handleSnackbar(true,
                `Layout missing for: ${emptyLayouts.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
                "error");
        }

        this.setState(errors);
        return isValid;
    };

    clearForm = () => {
        this.setState({
            recordId: 0,
            categoryId: "", categoryIdError: "",
            themeCategoryId: "", themeCategoryIdError: "",
            sizeId: "", sizeIdError: "",
            totalPages: "", totalPagesError: "",
            selectedProductTypes: [], selectedProductTypesError: "",
            selectedBundles: [], selectedBundlesError: "",
            description: "", descriptionError: "",
            themeLabel: "", themeLabelError: "",
            templateImages: [],
            previewImage: null, previewImageError: "",
            thumbnailImage: null, thumbnailImageError: "",
            folderUploadError: "",
        });
    };

    submitForm = async (e) => {
        e.preventDefault();
        if (!this.isFormValid()) return;
        this.setState({ isLoading: true });

        const data = new FormData();
        data.append("recordId", this.state.recordId);
        data.append("categoryId", this.state.categoryId);
        data.append("themeCategoryId", this.state.themeCategoryId);
        data.append("sizeId", this.state.sizeId);
        data.append("totalPages", this.state.totalPages);
        data.append("themeLabel", "Theme");
        data.append("description", this.state.description);

        // this.state.selectedProductTypes.forEach((pt) => data.append("productTypeId", pt.id));
        // this.state.selectedBundles?.forEach((b) => data.append("bundleId", b.id));

        const appAssets = this.state.templateImages.filter((s) => s.slotNumber === 1);
        const printAssets = this.state.templateImages.filter((s) => s.slotNumber === 2);
        appAssets.forEach((s) => { data.append("appAssets", s.file); data.append("appAssetLayoutIds", s.layoutId); });
        printAssets.forEach((s) => { data.append("printAssets", s.file); data.append("printAssetLayoutIds", s.layoutId); });

        if (this.state.previewImage) {
            data.append("previewFile", this.state.previewImage.file);
        }
        if (this.state.categoryId == 6 && this.state.thumbnailImage) {
            data.append("thumbnailFile", this.state.thumbnailImage.file);
        }

        const res = await HttpRequest("POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesSave`,
            data, "authorize");

        if (res.isSuccess) {
            this.handleSnackbar(true, "Saved Successfully", "success");
            this.clearForm();
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
            else this.handleSnackbar(true, res.message || "Save failed", "error");
        }
        this.setState({ isLoading: false });
    };

    // ── Render Helpers ──

    renderImageBox = (image, height, emptyLabel, errorFlag, onRemove) => (
        <>
            <div style={{
                width: "100%", height, backgroundColor: "#f5f5f5",
                border: image ? "1px solid #e0e0e0" : errorFlag ? "2px dashed #f44336" : "2px dashed #ccc",
                borderRadius: 8, overflow: "hidden",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
            >
                {image
                    ? <img src={image.preview} alt="img" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                    : <div style={{ textAlign: "center", color: "#bbb" }}>
                        <img src={ckLogo} alt="ck" style={{ width: "20%", objectFit: "contain" }} />
                        <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>{emptyLabel}</Typography>
                    </div>
                }
            </div>
            {image && (
                <Box mt={1}>
                    <Typography variant="caption" color="textSecondary"
                        style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        📄 {image.file.name}
                    </Typography>
                    {image.dimensions && (
                        <Typography variant="caption" style={{ color: "#888", display: "block" }}>
                            📐 {image.dimensions.width} × {image.dimensions.height} px
                        </Typography>
                    )}
                    <Box display="flex" justifyContent="flex-end">
                        <Tooltip title="Remove">
                            <IconButton size="small" onClick={onRemove} style={{ color: "#f44336", padding: 4 }}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            )}
        </>
    );

    render() {
        const { classes } = this.props;
        const { categoriesList, themeCategoriesList, sizesList, productTypesList, selectedProductTypes } = this.state;
        const filledCount = this.state.templateImages.filter((s) => s.file).length;
        const totalCount = this.state.templateImages.length;

        return (
            <Fragment>
                <LoginMenu reload={this.state.isReload} open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })} />
                <CustomizedSnackbar isOpen={this.state.isOpenSnackbar} message={this.state.snackbarMessage}
                    severity={this.state.snackbarSeverity}
                    handleCloseSnackbar={() => this.handleSnackbar(false, "", "")} autoHideDuration={3000} />

                <Grid container xs={12} direction="column" justifyContent="center" alignItems="center" style={{ padding: 10 }}>
                    <Toolbar>
                        <NavBar isAuthorize title="Add New Theme With Folder" />
                    </Toolbar>

                    <Card style={{ width: "98%", paddingBottom: 100, paddingLeft: 20, paddingRight: 20 }}>
                        <CardContent>
                            <Typography variant="h5" color="primary" style={{ fontWeight: 700, marginBottom: 8 }}>
                                {this.state.recordId == 0 ? "Add New Theme With Folder" : "Edit Theme With Folder"}
                            </Typography>
                            <Divider style={{ marginBottom: 24 }} />

                            <Grid container spacing={2}>

                                {/* ── Category ── */}
                                <Grid item xs={12} sm={6}>
                                    <TextField select id="categoryId" name="categoryId" fullWidth label="Category *"
                                        variant="outlined" onChange={this.handleChange} value={this.state.categoryId}
                                        error={!!this.state.categoryIdError} helperText={this.state.categoryIdError}
                                        disabled={this.state.categoriesLoading} size="small">
                                        {categoriesList.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.label || item.userLabel || ""}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                {/* ── Theme Category ── */}
                                <Grid item xs={12} sm={6}>
                                    <TextField select id="themeCategoryId" name="themeCategoryId" fullWidth
                                        label="Theme Category *" variant="outlined" onChange={this.handleChange}
                                        value={this.state.themeCategoryId} error={!!this.state.themeCategoryIdError}
                                        helperText={this.state.themeCategoryIdError}
                                        disabled={this.state.themeCategoriesLoading} size="small">
                                        {themeCategoriesList.map((item) => {
                                            const isDisabled = [2, 6].includes(parseInt(this.state.categoryId)) && item.id === 3;
                                            return (
                                                <MenuItem key={item.id} value={item.id} disabled={isDisabled}>
                                                    {item.categoryLabel || item.label || ""}
                                                    {isDisabled ? " (Not available for this category)" : ""}
                                                </MenuItem>
                                            );
                                        })}
                                    </TextField>
                                </Grid>

                                {/* ── Size ── */}
                                <Grid item xs={12} sm={6}>
                                    <TextField select id="sizeId" name="sizeId" fullWidth label="Size *"
                                        variant="outlined" onChange={this.handleChange} value={this.state.sizeId}
                                        error={!!this.state.sizeIdError} helperText={this.state.sizeIdError}
                                        disabled={this.state.sizesLoading} size="small">
                                        {sizesList.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.label || item.userLabel || ""}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                {/* ── Product Types ── */}
                                <Grid item xs={12} sm={6}>
                                    <Select isMulti value={selectedProductTypes} name="productTypesList"
                                        options={productTypesList} onChange={this.handleProductTypesChange}
                                        className="basic-multi-select" classNamePrefix="select"
                                        placeholder="Select product types..." isLoading={this.state.productTypesLoading}
                                        styles={{
                                            option: (base) => ({ ...base, backgroundColor: "#FFFFFF" }),
                                            control: (base) => ({
                                                ...base,
                                                borderColor: this.state.selectedProductTypesError ? "#f44336" : base.borderColor,
                                                minHeight: 40,
                                            }),
                                        }} />
                                    {this.state.selectedProductTypesError && (
                                        <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
                                            {this.state.selectedProductTypesError}
                                        </Typography>
                                    )}
                                </Grid>

                                {/* ── Bundles — Mug only ── */}
                                {this.state.categoryId == 9 && (
                                    <Grid item xs={12} sm={6}>
                                        <Select isMulti value={this.state.selectedBundles} name="bundlesList"
                                            options={this.state.bundlesList} onChange={this.handleBundlesChange}
                                            className="basic-multi-select" classNamePrefix="select"
                                            placeholder="Select bundles..." isLoading={this.state.bundlesLoading}
                                            styles={{
                                                option: (base) => ({ ...base, backgroundColor: "#FFFFFF" }),
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: this.state.selectedBundlesError ? "#f44336" : base.borderColor,
                                                    minHeight: 40,
                                                }),
                                            }} />
                                        {this.state.selectedBundlesError && (
                                            <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
                                                {this.state.selectedBundlesError}
                                            </Typography>
                                        )}
                                    </Grid>
                                )}

                                {/* ── Description ── */}
                                <Grid item xs={12} sm={6}>
                                    <TextField autoComplete="off" id="description" name="description"
                                        label="Description *" variant="outlined" onChange={this.handleChange}
                                        value={this.state.description} error={!!this.state.descriptionError}
                                        helperText={this.state.descriptionError} fullWidth multiline rows={2}
                                        inputProps={{ maxLength: 500 }} size="small" />
                                </Grid>

                                {/* ════════════════════════════════════════
                                    FOLDER UPLOAD — visible once categoryId set
                                ════════════════════════════════════════ */}
                                {!!this.state.categoryId && (
                                    <Grid item xs={12}>
                                        <Divider style={{ margin: "8px 0 16px" }} />

                                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                            <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
                                                Upload Theme Folder
                                            </Typography>
                                            <Typography variant="caption" style={{ color: "#888" }}>
                                                Expected subfolders: <strong>App Asset</strong>, <strong>Print Asset</strong>, <strong>Preview</strong>
                                                {this.state.categoryId == 6 && <>, <strong>Thumbnail</strong></>}
                                            </Typography>
                                        </Box>

                                        {/* Drop Zone */}
                                        <input
                                            type="file"
                                            id="folder-upload-input"
                                            webkitdirectory="true"
                                            directory="true"
                                            multiple
                                            style={{ display: "none" }}
                                            onChange={this.handleFolderUpload}
                                        />
                                        <label htmlFor="folder-upload-input" style={{ display: "block", cursor: "pointer" }}>
                                            <Box style={{
                                                border: this.state.folderUploadError ? "2px dashed #f44336" : "2px dashed #1976d2",
                                                borderRadius: 8, padding: "28px 16px", textAlign: "center",
                                                backgroundColor: "#f5f9ff",
                                            }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e8f0fe"}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#f5f9ff"}
                                            >
                                                <FolderOpenIcon style={{ fontSize: 44, color: "#1976d2", marginBottom: 8 }} />
                                                <Typography variant="body2" style={{ color: "#1976d2", fontWeight: 600 }}>
                                                    Click to select theme folder
                                                </Typography>
                                                <Typography variant="caption" style={{ color: "#888", display: "block", marginTop: 4 }}>
                                                    Select the root folder containing: App Asset, Print Asset, Preview
                                                    {this.state.categoryId == 6 ? ", Thumbnail" : ""}
                                                </Typography>
                                            </Box>
                                        </label>

                                        {this.state.folderUploadError && (
                                            <Typography variant="caption"
                                                style={{ color: "#f44336", display: "block", marginTop: 6, whiteSpace: "pre-line" }}>
                                                {this.state.folderUploadError}
                                            </Typography>
                                        )}

                                        {/* Upload summary */}
                                        {totalCount > 0 && (
                                            <Box mt={1.5} display="flex" alignItems="center" style={{ gap: 16 }}>
                                                <Typography variant="caption" style={{ color: filledCount === totalCount ? "#2e7d32" : "#e65100", fontWeight: 600 }}>
                                                    Assets: {filledCount} / {totalCount} filled
                                                </Typography>
                                                <Typography variant="caption" style={{ color: this.state.previewImage ? "#2e7d32" : "#e65100", fontWeight: 600 }}>
                                                    Preview: {this.state.previewImage ? "✓" : "✗"}
                                                </Typography>
                                                {this.state.categoryId == 6 && (
                                                    <Typography variant="caption" style={{ color: this.state.thumbnailImage ? "#2e7d32" : "#e65100", fontWeight: 600 }}>
                                                        Thumbnail: {this.state.thumbnailImage ? "✓" : "✗"}
                                                    </Typography>
                                                )}
                                            </Box>
                                        )}
                                    </Grid>
                                )}

                                {/* ── Preview & Thumbnail (manual upload / replacement) ── */}
                                {!!this.state.categoryId && (
                                    <Grid item xs={12}>
                                        <Divider style={{ margin: "8px 0 16px" }} />
                                        <Typography variant="h6" color="primary" style={{ fontWeight: 600, marginBottom: 16 }}>
                                            {this.state.categoryId == 6 ? "Preview & Thumbnail Images" : "Preview Image"}
                                        </Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}>
                                                    Preview Image <span style={{ color: "#f44336" }}>*</span>
                                                </Typography>
                                                <input type="file" accept="image/*" id="preview-image-upload" style={{ display: "none" }}
                                                    onChange={(e) => { const f = e.target.files[0]; if (f) this.handlePreviewImageUpload(f); e.target.value = ""; }} />
                                                <label htmlFor="preview-image-upload" style={{ cursor: "pointer", display: "block" }}>
                                                    <Tooltip title={this.state.previewImage ? "Click to replace" : "Click to upload"}>
                                                        {this.renderImageBox(this.state.previewImage, 160, "Click to upload Preview",
                                                            !!this.state.previewImageError, this.handlePreviewImageRemove)}
                                                    </Tooltip>
                                                </label>
                                                {this.state.previewImageError && (
                                                    <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
                                                        {this.state.previewImageError}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            {this.state.categoryId == 6 && (
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}>
                                                        Thumbnail Image <span style={{ color: "#f44336" }}>*</span>
                                                    </Typography>
                                                    <input type="file" accept="image/*" id="thumbnail-image-upload" style={{ display: "none" }}
                                                        onChange={(e) => { const f = e.target.files[0]; if (f) this.handleThumbnailImageUpload(f); e.target.value = ""; }} />
                                                    <label htmlFor="thumbnail-image-upload" style={{ cursor: "pointer", display: "block" }}>
                                                        <Tooltip title={this.state.thumbnailImage ? "Click to replace" : "Click to upload"}>
                                                            {this.renderImageBox(this.state.thumbnailImage, 160, "Click to upload Thumbnail",
                                                                !!this.state.thumbnailImageError, this.handleThumbnailImageRemove)}
                                                        </Tooltip>
                                                    </label>
                                                    {this.state.thumbnailImageError && (
                                                        <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
                                                            {this.state.thumbnailImageError}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                )}

                                {/* ── Asset Slots per page ── */}
                                {this.state.templateImages.length > 0 && (
                                    <Grid item xs={12}>
                                        <Divider style={{ margin: "8px 0 16px" }} />
                                        <Typography variant="h6" color="primary" style={{ fontWeight: 600, marginBottom: 16 }}>
                                            Asset Slots
                                            <span style={{ fontSize: 13, color: "#888", fontWeight: 400, marginLeft: 8 }}>
                                                ({filledCount} / {totalCount} filled)
                                            </span>
                                        </Typography>

                                        {Array.from({ length: totalCount / 2 }, (_, i) => i + 1).map((pageNumber) => {
                                            const appSlot = this.state.templateImages.find((s) => s.pageNumber === pageNumber && s.slotNumber === 1);
                                            const printSlot = this.state.templateImages.find((s) => s.pageNumber === pageNumber && s.slotNumber === 2);
                                            const pageLayoutId = appSlot?.layoutId || "";
                                            const pageLayoutError = appSlot?.layoutIdError || "";

                                            return (
                                                <Box key={pageNumber} mb={2}>
                                                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}>
                                                        Page {pageNumber}
                                                    </Typography>
                                                    <Grid container spacing={2} alignItems="stretch">

                                                        {[appSlot, printSlot].map((slot) => slot && (
                                                            <Grid item xs={12} sm={5} key={slot.slotKey} style={{ display: "flex" }}>
                                                                <Card elevation={2} style={{ borderRadius: 8, width: "100%", display: "flex", flexDirection: "column" }}>
                                                                    <input type="file" accept="image/*"
                                                                        id={`slot-upload-${slot.slotKey}`} style={{ display: "none" }}
                                                                        onChange={(e) => { const f = e.target.files[0]; if (f) this.handleTemplateImageUpload(slot.slotKey, f); e.target.value = ""; }} />
                                                                    <label htmlFor={`slot-upload-${slot.slotKey}`} style={{ cursor: "pointer", display: "block" }}>
                                                                        <Tooltip title={slot.preview ? "Click to replace" : "Click to upload"}>
                                                                            <div style={{
                                                                                width: "100%", height: 140, backgroundColor: "#f5f5f5",
                                                                                border: slot.preview ? "1px solid #e0e0e0" : "2px dashed #ccc",
                                                                                borderRadius: "8px 8px 0 0", overflow: "hidden",
                                                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                                            }}
                                                                                onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                                                                                onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
                                                                            >
                                                                                {slot.preview
                                                                                    ? <img src={slot.preview} alt={slot.slotKey} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                                                    : <div style={{ textAlign: "center", color: "#bbb" }}>
                                                                                        <img src={ckLogo} alt="ck" style={{ width: "20%", objectFit: "contain" }} />
                                                                                        <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>Click to upload</Typography>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </Tooltip>
                                                                    </label>
                                                                    <CardContent style={{ padding: "8px 10px" }}>
                                                                        <Typography variant="caption" style={{ fontWeight: 600, color: slot.slotNumber === 1 ? "#1976d2" : "#e65100", display: "block", marginBottom: 2 }}>
                                                                            {slot.slotLabel}
                                                                        </Typography>
                                                                        {slot.file && (
                                                                            <Typography variant="caption" color="textSecondary"
                                                                                style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2 }}
                                                                                title={slot.generatedFileName || slot.file.name}>
                                                                                📄 {slot.generatedFileName || slot.file.name}
                                                                            </Typography>
                                                                        )}
                                                                        {slot.dimensions && (
                                                                            <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
                                                                                📐 {slot.dimensions.width} × {slot.dimensions.height} px
                                                                            </Typography>
                                                                        )}
                                                                        {slot.preview && (
                                                                            <Box display="flex" justifyContent="flex-end">
                                                                                <Tooltip title="Remove">
                                                                                    <IconButton size="small" onClick={() => this.handleTemplateImageRemove(slot.slotKey)} style={{ color: "#f44336", padding: 4 }}>
                                                                                        <CloseIcon fontSize="small" />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </Box>
                                                                        )}
                                                                    </CardContent>
                                                                </Card>
                                                            </Grid>
                                                        ))}

                                                        {/* Layout Dropdown — shared per page */}
                                                        <Grid item xs={12} sm={2} style={{ display: "flex" }}>
                                                            <Card elevation={2} style={{ borderRadius: 8, width: "100%", padding: 12 }}>
                                                                <Typography variant="caption" style={{ fontWeight: 600, color: "#555", display: "block", marginBottom: 8 }}>
                                                                    Layout
                                                                </Typography>
                                                                <Select
                                                                    isClearable isSearchable
                                                                    placeholder="Select..."
                                                                    value={pageLayoutId
                                                                        ? this.state.layoutsList
                                                                            .map((l) => ({ value: l.layoutId, label: l.layoutNo + (l.label ? ` - ${l.label}` : "") }))
                                                                            .find((o) => o.value === pageLayoutId) || null
                                                                        : null}
                                                                    options={this.state.layoutsList.map((l) => ({
                                                                        value: l.layoutId,
                                                                        label: l.layoutNo + (l.label ? ` - ${l.label}` : ""),
                                                                    }))}
                                                                    onChange={(selected) => {
                                                                        const newLayoutId = selected ? selected.value : "";
                                                                        this.setState((prev) => ({
                                                                            templateImages: prev.templateImages.map((s) =>
                                                                                s.pageNumber !== pageNumber ? s
                                                                                    : { ...s, layoutId: newLayoutId, layoutIdError: "" }
                                                                            ),
                                                                        }));
                                                                    }}
                                                                    styles={{
                                                                        control: (base) => ({ ...base, borderColor: pageLayoutError ? "#f44336" : base.borderColor, minHeight: 36 }),
                                                                        option: (base) => ({ ...base, backgroundColor: "#fff", color: "#333", "&:hover": { backgroundColor: "#f5f5f5" } }),
                                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                                {pageLayoutError && (
                                                                    <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
                                                                        {pageLayoutError}
                                                                    </Typography>
                                                                )}
                                                                <Typography variant="caption" style={{ color: "#888", marginTop: 4, display: "block" }}>
                                                                    Shared for App & Print
                                                                </Typography>
                                                            </Card>
                                                        </Grid>
                                                    </Grid>
                                                    <Divider style={{ marginTop: 12 }} />
                                                </Box>
                                            );
                                        })}
                                    </Grid>
                                )}

                                {/* ── Action Buttons ── */}
                                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                                    <Button onClick={(e) => this.submitForm(e)} className={classes.button}
                                        color="primary" variant="contained" disabled={this.state.isLoading}>
                                        {this.state.isLoading
                                            ? <CircularProgress size={23} style={{ color: "white" }} />
                                            : this.state.recordId == 0 ? "Save" : "Update"}
                                    </Button>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Fragment>
        );
    }
}

F15ThemeProductsAssetsFormWithFolder.propTypes = {
    classes: PropTypes.object.isRequired,
    match: PropTypes.object,
};

F15ThemeProductsAssetsFormWithFolder.defaultProps = {
    match: { params: { recordId: 0 } },
};

export default withStyles(useStyles)(F15ThemeProductsAssetsFormWithFolder);